export default "__VITE_ASSET__w7VVB_B6__"